<modal
  *ngIf="isModalOpen"
  [modalConfiguration]="modalConfiguration"
  (modalCloseEvent)="closeModal()"
>
  <div *ngIf="!isOtpVerified" class="px-3 mt-2 main-div">
    <p class="h4 fw-bold">OTP Verification</p>
    @if (isConsentRequired()) {
      <div class="d-flex">
        <label class="checkbox-container">
          <input
            [type]="'checkbox'"
            [id]="'consent'"
            [checked]="isConsentGiven()"
            (change)="giveConsent($event)"
          />
          <span class="checkmark"></span>
        </label>
        <div class="toc-trigger">
          {{ consentMessage }}
        </div>
      </div>
      <div class="line-wrap-otp"></div>
    }
    <p *ngIf="!isMaxWrongAttempt && !errorMessage && isConsentGiven()">
      Enter 6 digit OTP code sent to {{ phoneNumber | cellPhoneFormat }}
    </p>
    <div
      *ngIf="errorMessage"
      class="alert alert-danger d-flex align-items-center w-100 error-msg bg-warn"
      role="alert"
    >
      <img
        src="./assets/icons/error_icon.svg"
        alt="Error icon"
        class="me-2"
        style="line-height: 19px"
      />
      <span>{{ errorMessage }}</span>
    </div>
    <div class="d-flex align-items-center">
      <p class="fw-700 icon-spacer">OTP Code</p>
      <img
        class="info-icon"
        src="./assets/icons/info.svg"
        alt=""
        pTooltip="{{ OtpInfo }}"
        tooltipZIndex="10000"
      />
    </div>
    <div>
      <input
        type="text"
        (input)="onOtpInput($event)"
        class="n-form-control w-100"
        [maxLength]="6"
        Placeholder="Enter OTP Code"
        [readonly]="
          isMaxWrongAttempt || (isConsentRequired() && !isConsentGiven())
        "
        [(ngModel)]="enteredOTP"
        autocompleteOff
        preventSpace
      />
    </div>
    @if (isConsentGiven()) {
      <div
        *ngIf="
          !(this.showResendButton === undefined) &&
          !isMaxWrongAttempt &&
          !errorMessage
        "
      >
        <div>
          <span *ngIf="!showResendButton" class="remaining-time"
            >Resend OTP code in: 00:{{ this.resendTimeRemaining }}</span
          >
        </div>
        <div>
          <a *ngIf="showResendButton" class="resend-otp" (click)="sendOTP()"
            >Resend OTP Code</a
          >
        </div>
      </div>
    }
  </div>
  <div *ngIf="isOtpVerified" class="verification-msg text-center mt-3 main-div">
    <p class="h4 fw-bold">OTP Verification</p>
    <div class="d-flex justify-content-center align-items-center mt-3">
      <img
        src="./assets/icons/success_icon.svg"
        alt="Check"
        class="success-icon me-2"
      />
    </div>
    <p class="mt-3 fw-bold">Successfully Verified</p>
  </div>
</modal>
